export function showError(message: string) {
    const errorContainer = document.querySelector('.js-error-container');
    if (!errorContainer) {return;}
    const p = document.createElement('p');
    p.className = 'error';
    p.textContent = message;
    errorContainer.appendChild(p);
    errorContainer.classList.add('is-visible');
    errorContainer.removeAttribute('aria-hidden');
}

export function clearErrors() {
    const errorContainer = document.querySelector('.js-error-container');
    if (!errorContainer) {return;}
    errorContainer.innerHTML = '';
    errorContainer.classList.remove('is-visible');
    errorContainer.setAttribute('aria-hidden', 'true');
}
